import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PunchInComponent } from './punch-in.component';

@NgModule({
  declarations: [PunchInComponent],
  imports: [CommonModule],
  exports: [PunchInComponent],
})
export class PunchInModule {}
